<template>
  <div class="qrcode-viewer">
    <div class="has-text-centered" v-if="isLoading">
      <button
        disabled="disabled"
        class="button is-loading is-disabled is-white"
      >
        ...
      </button>
    </div>
    <div class="has-text-centered" v-if="!isLoading && QrUrl">
      <p>
        <img :src="QrUrl" alt="Qr Code" class="qrcode" />
      </p>
      <a
        :href="QrUrl"
        class="button"
        :download="name ? `qrcode-${name}.png` : 'qrcode.png'"
        v-if="allowDownload"
      >
        <span class="icon">
          <i class="fa fa-cloud-download"></i>
        </span>
        <span>Download</span>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'QrCodeViewer',
  props: {
    isLoading: {
      type: Boolean,
      default: false
    },
    allowDownload: {
      type: Boolean,
      default: false
    },
    url: {
      type: String,
      required: true,
      default: ''
    },
    name: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      QrUrl: ''
    }
  },
  created () {
    this.QrUrl = this.url
  },
  watch: {
    url (value) {
      if (value) {
        this.QrUrl = value
      }
    }
  }
}
</script>

<style lang="scss">
.qrcode-viewer {
  .qrcode {
    width: 150px;
    height: 150px;
  }
  .button {
    display: inline-block;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/QrCodeViewer.vue